import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f444dc04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "noRoutesCardWrapper" }
const _hoisted_3 = { class: "noRoutesTitle" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "noRoutesButtonWrapper"
}
const _hoisted_6 = {
  key: 2,
  class: "addRouteWrapper"
}

import {
  Ref,
  computed, ref,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useDictionary } from '@components/dictionary';
import { useI18n } from 'vue-i18n';
import { Card, Icon } from '../../Atoms';
import { useRouteSubscriptionStore } from '../../stores/useRouteSubscriptionStore';
import { AddRouteSubscription } from '../AddRouteSubscription';
import { markdownToHtml } from '../../helpers';
import { RouteDetail, RouteSubscriptionViewModel } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoRoutesCard',
  props: {
    routes: {}
  },
  setup(__props: any) {



const { t } = useI18n();
const { DictionaryField, dictionary } = useDictionary();

const routeSubscriptionsStore = useRouteSubscriptionStore();
const {
  addSubscription, getSubscriptions,
} = routeSubscriptionsStore;

const { isSubscriptionAdding } = storeToRefs(routeSubscriptionsStore);

const showInstructions = ref(false);
const apiError = ref('');

const subscription: Ref<RouteSubscriptionViewModel> = ref({
  startDate: undefined,
  endDate: undefined,
  routeCode: undefined,
});

const noRoutesIntro = computed(() => markdownToHtml(dictionary.value[DictionaryField['SMS:Web:NoRoutes:Intro']]));

const clearAddRouteValues = () => {
  subscription.value = {
    startDate: undefined,
    endDate: undefined,
    textCode: undefined,
  };
};

const handleAddRoute = () => {
  showInstructions.value = true;
};

const handleUpdateStartDate = (value: string) => {
  subscription.value.startDate = value;
};

const handleUpdateEndDate = (value: string) => {
  subscription.value.endDate = value;
};

const handleUpdateTextCode = (value: string) => {
  subscription.value.textCode = value;
};

const handleSave = async () => {
  apiError.value = '';

  addSubscription(
    {
      routeSubscription: {
        startDate: subscription.value.startDate || '',
        endDate: subscription.value.endDate || '',
        textCode: subscription.value.textCode || '',
      },
      onApiSuccess: () => {
        clearAddRouteValues();
        getSubscriptions();
      },
      onApiError: () => {
        apiError.value = t('SMS Api error');
      },
    },
  );
};

const handleCancel = () => {
  showInstructions.value = false;
  apiError.value = '';
  clearAddRouteValues();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card), { class: "noRoutesCard" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(dictionary)[_unref(DictionaryField)['SMS:Web:NoRoutes:Title']]), 1),
          (noRoutesIntro.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "noRoutesContent",
                innerHTML: noRoutesIntro.value
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!showInstructions.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "button noRoutesButton",
                  onClick: handleAddRoute
                }, [
                  _createVNode(_unref(Icon), { "icon-name": "plus" }),
                  _createTextVNode(" " + _toDisplayString(_unref(dictionary)[_unref(DictionaryField)['SMS:Web:AddNewRoute']]), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(AddRouteSubscription), {
                  "start-date": subscription.value.startDate,
                  "end-date": subscription.value.endDate,
                  routes: _ctx.routes,
                  "text-code": subscription.value.textCode,
                  "alert-description-markdown": 
              _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Alert:Description']]
            ,
                  "alert-title": _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Alert:Title']],
                  "how-it-works-description-markdown": 
              _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Description']]
            ,
                  "how-it-works-title": 
              _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Title']]
            ,
                  "show-instructions": showInstructions.value,
                  "api-error": apiError.value,
                  "is-loading": _unref(isSubscriptionAdding),
                  onUpdateEndDate: handleUpdateEndDate,
                  onUpdateStartDate: handleUpdateStartDate,
                  onUpdateTextCode: handleUpdateTextCode,
                  onSave: handleSave,
                  onCancel: handleCancel
                }, null, 8, ["start-date", "end-date", "routes", "text-code", "alert-description-markdown", "alert-title", "how-it-works-description-markdown", "how-it-works-title", "show-instructions", "api-error", "is-loading"])
              ]))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})